import React from 'react';

import { Count } from './styles';

const Counter = ({ className, value }) => {
  return <Count className={className}>{value}</Count>;
};

export default Counter;
